export const compareHistoryItems = function (
  tournament,
  historyItem1,
  historyItem2
) {
  const useSets = (tournament.useSets || "0") === "1";
  if (useSets) {
    const sets1 = historyItem1.sets || {};
    const sets2 = historyItem2.sets || {};
    return JSON.stringify(sets1) === JSON.stringify(sets2);
  } else {
    return (
      historyItem1.score1 === historyItem2.score1 &&
      historyItem1.score2 === historyItem2.score2
    );
  }
};
